import { HORIZONTAL_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const youtubePage: TemplatePage = {
  header: {
    color: '#F79A88',
    icon: 'images/video-templates/youtube-video.jpg',
    title: 'YouTube Video Templates Collection',
    title_meta: '200+ Easy-to-Use Free YouTube Video Templates',
    description_meta:
      'Save time on creating engaging video content for your channel with Wave.video’s 200+ easy-to-edit YouTube video templates.',
    description:
      'Save time on creating engaging video content for your channel with these 200+ easy-to-edit YouTube video templates. ' +
      'Grow subscribers and get more exposure on YouTube with videos that your viewers won’t want to miss.'
  },
  footer: {
    category: 'YouTube',
    description:
      'With Wave.video’s easy-to-edit YouTube video templates, you won’t need to hire a high-end graphic designer and ' +
      'videographer to make thumb-stopping videos. Just pick a template that suits your needs best, customize the template ' +
      'to your branding, and download or share directly to YouTube. Easy as one-two-three!'
  },
  content: [
    {
      type: 'templates',
      title: 'YouTube video',
      search: {
        aspects: HORIZONTAL_ASPECTS_STRING,
        price_min: '0'
      }
    },
    {
      type: 'stocks',
      title: 'youtube',
      search: { name: 'youtube' }
    },
    { type: 'calendar' }
  ]
};

export default youtubePage;
